import * as React from 'react';
import { cn } from '../lib/utils';

function Carousel({ className, children, ...props }: React.ComponentProps<'ul'>) {
	return (
		<ul className={cn('carousel flex w-full touch-pan-x gap-4 px-6', className)} {...props}>
			{children}
		</ul>
	);
}

function CarouselItem({ className, ...props }: React.ComponentProps<'li'>) {
	return <li className={cn('shrink-0', className)} {...props} />;
}

export { Carousel, CarouselItem };
